import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediStyles from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        display: 'flex',
        flexDirection: 'column',
        margin: 0,
      },
      item: {
        display: 'flex',
        flexDirection: 'column',
        '&:not(:last-of-type)': {
          borderBottom: `1px solid ${sicrediStyles.secondarySicrediLight}`,
        },
      },
      header: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: theme.spacing(),
        [theme.breakpoints.down('xs')]: {
          flexDirection: 'column',
        },
      },
      title: {
        flex: 'auto',
        margin: 0,
        fontSize: 14,
        fontWeight: 600,
        color: sicrediStyles.secondarySicrediDarker,
        wordBreak: 'break-word',
        paddingRight: '10px',
        [theme.breakpoints.down('xs')]: {
          paddingRight: '0',
        },
      },
      button: {
        flexShrink: 0,
        fontSize: 16,
        fontWeight: 300,
        textTransform: 'capitalize',
        color: sicrediStyles.primarySicredi,
        padding: '0 8px',
        [theme.breakpoints.down('xs')]: {
          marginTop: '5px',
        },
      },
      description: {
        padding: theme.spacing(),
        margin: 0,
        fontSize: 12,
        color: sicrediStyles.secondarySicrediDarker,
      },
      descriptionMobile: {
        [theme.breakpoints.up('sm')]: {
          display: 'none',
        },
      },
      descriptionDesktop: {
        [theme.breakpoints.down('sm')]: {
          display: 'none',
        },
      },
    }),
  { name: 'AssembleiaDocumentos' }
);
